import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Card, Grid, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import CustomSelect from "../../../../components/Select/Select";
import { getServices } from "../../../../redux/reducers/clinicSlice";
import { updateDiagnostics } from "../../../../redux/reducers/petSlice";
import {
  getTreatmentBundleByAppointmentId,
  updateTreatmentBundleItemStatusById,
  updateTreatmentBundlePrescriptionStatusById,
} from "../../../../redux/reducers/planSlice";
import { AppColors } from "../../../../util/AppColors";
import { getTotalEstimatedCost } from "../../../../util/function";
import FilesWithCloseButton from "../PatientWorkbook/FilesWithCloseButton";

const cardSty = {
  borderRadius: 1,
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 1,
  paddingBottom: 1,
  borderTopColor: AppColors.appPrimary,
};

const Task = () => {
  const dispatch = useDispatch();
  const [treatOpen, setTreatOpen] = useState(true);
  const [presOpen, setPresOpen] = useState(true);
  const [slctedItem, setSlctedItem] = useState(null);
  const [updateModVsble, setUpdateModVsble] = useState(false);
  const [updateValues, setUpdateValues] = useState({});
  const appData = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petDetails = useSelector((state) => state?.pet?.petDetails);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { treatBundlesByApntId } = useSelector((state) => state?.plan);
  const services = useSelector((state) => state?.clinic?.services);
  const reqBundle = treatBundlesByApntId?.[0];

  useEffect(() => {
    if (!apntDet?.appointment?.appointmentId) return;
    dispatch(
      getTreatmentBundleByAppointmentId(apntDet?.appointment?.appointmentId)
    );
    dispatch(getServices());
  }, [apntDet?.appointment?.appointmentId]);

  const handleTreatOpen = () => {
    setTreatOpen(!treatOpen);
  };

  const getServiceById = (serviceId) => {
    return services?.data?.find((ser) => ser?.serviceId === serviceId) ?? null;
  };

  const handleUpdateStatus = (details, status, reason = null) => {
    if (status) {
      const reqService = getServiceById(details?.serviceId);
      if (
        reqService?.category === "Diagnostics" ||
        reqService?.category === "Vaccination" ||
        reqService?.subCategory === "Vaccination"
      ) {
        setUpdateValues({
          type: reqService?.serviceName,
          dueDate: apntDet?.appointment?.appointmentDate
            ? new Date(apntDet?.appointment?.appointmentDate)
            : new Date(),
        });
        setSlctedItem(details);
        setUpdateModVsble(true);
        return;
      }
    }
    let url = `?status=${status}&reason=${reason}`;
    dispatch(
      updateTreatmentBundleItemStatusById({
        detailId: details?.detailId,
        url,
      })
    ).then((res) => {
      if (res?.payload) {
        dispatch(
          getTreatmentBundleByAppointmentId(apntDet?.appointment?.appointmentId)
        );
      }
    });
  };

  const handleUpdatePresStatus = (prescriptionId, status) => {
    dispatch(
      updateTreatmentBundlePrescriptionStatusById({
        prescriptionId,
        url: `?status=${status}`,
      })
    ).then((res) => {
      if (res?.payload) {
        dispatch(
          getTreatmentBundleByAppointmentId(apntDet?.appointment?.appointmentId)
        );
      }
    });
  };

  const handlePresOpen = () => {
    setPresOpen(!presOpen);
  };

  const handleCloseUpdateMod = () => {
    setSlctedItem(null);
    setUpdateModVsble(false);
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists =
      updateValues?.files?.length > 0 ? [...updateValues?.files] : [];

    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setUpdateValues({ ...updateValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (ind) => {
    const reqFiles = updateValues?.files?.filter((fl, i) => i !== ind);
    setUpdateValues({ ...updateValues, files: reqFiles });
  };

  const getList = () => {
    return services?.data
      ?.filter(
        (dl) =>
          dl?.category?.toLowerCase() === "diagnostics" ||
          dl?.category?.toLowerCase() === "vaccination" ||
          dl?.subCategory?.toLowerCase() === "vaccination"
      )
      ?.map((dl) => ({
        ...dl,
        name: dl?.serviceName,
        value: dl?.serviceName,
      }));
  };

  const handleChange = (name, value) => {
    setUpdateValues({ ...updateValues, [name]: value });
  };

  const handleComplete = () => {
    if (!slctedItem?.serviceId) return;
    const reqService = getServiceById(slctedItem?.serviceId);
    const form = new FormData();
    form.append("appId", apntDet?.appointment?.appointmentId);
    form.append("type", updateValues?.type);
    form.append(
      "dueDate",
      moment(new Date(updateValues?.dueDate)).format("YYYY-MM-DD")
    );
    form.append("remark", updateValues?.remarks);
    form.append("status", "Completed");
    if (slctedItem?.serviceId) {
      form.append("serviceId", slctedItem?.serviceId);
    }
    form.append("price", Number(reqService?.servicePrice) ?? 0);
    form.append("tax", Number(reqService?.tax) ?? 0);
    if (updateValues?.files?.length > 0) {
      updateValues?.files?.forEach((fle) => {
        form.append("file", fle?.file ?? fle?.previewUrl);
      });
    }
    dispatch(
      updateTreatmentBundleItemStatusById({
        detailId: slctedItem?.detailId,
        url: `?status=${true}&reason=added`,
      })
    ).then((res) => {
      if (res?.payload) {
        try {
          const metaUpdate = { diagnosticsId: slctedItem?.diagnosticsId, form };
          dispatch(updateDiagnostics(metaUpdate));
        } catch (err) {
          console.log("err", err);
        }
        dispatch(
          getTreatmentBundleByAppointmentId(apntDet?.appointment?.appointmentId)
        );
        handleCloseUpdateMod();
      }
    });
  };

  return (
    <>
      <div className="scroll-90vh w100Per pb30">
        <Grid container spacing={0} className="flex-center">
          <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
            <div className="green-box">
              <div className="flex-row-between-align-center p10">
                <Typography className="blue-color fs16 txt-semi-bold">
                  Selected Bundle
                </Typography>
                <img
                  src={require("../../../../assets/images/png/editPen.png")}
                  className="img-wh20"
                />
              </div>
              <div className="ph10">
                <div className="gry-hor-split2" />
              </div>
              <div className="flex-row-ali-cen ph10 mt10">
                <div className="w25Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-medium fs14 gray23">
                      Pet Name:
                    </Typography>
                    <Typography className="font-medium fs14 gray24 ml5">
                      {appData?.appointment?.petName ?? petDetails?.petName}
                    </Typography>
                  </div>
                </div>
                <div className="w25Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-medium fs14 gray23">
                      Species:
                    </Typography>
                    <Typography className="font-medium fs14 gray24 ml5">
                      {reqBundle?.species?.join(", ")}
                    </Typography>
                  </div>
                </div>
                <div className="w25Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-medium fs14 gray23">
                      Type:
                    </Typography>
                    <Typography className="font-medium fs14 gray24 ml5">
                      {reqBundle?.usageType}
                    </Typography>
                  </div>
                </div>
                <div className="w25Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="font-medium fs14 gray23">
                      Estimated duration:
                    </Typography>
                    <Typography className="font-medium fs14 gray24 ml5">
                      30 mins
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="flex-row-wrap ph10 mt5 mb10">
                <Typography className="font-medium fs14 gray23">
                  Description:
                </Typography>
                <Typography className="font-medium fs14 gray24 ml5">
                  {reqBundle?.description}
                </Typography>
              </div>
              <div className="grn-back-box">
                <div className="flex-row-between-align-center ph5">
                  <Typography className="fs14 orange5 txt-semi-bold">
                    Estimated Cost
                  </Typography>
                  <Typography className="fs14 orange5 font-bold">
                    Rs.{" "}
                    {Number(
                      getTotalEstimatedCost(reqBundle?.treatmentBundleDetails)
                    )?.toFixed(2)}
                  </Typography>
                </div>
              </div>
            </div>

            <Card sx={cardSty} className="mt20">
              <div
                className="flex-row-ali-cen cursor"
                onClick={handleTreatOpen}
              >
                {treatOpen ? (
                  <ArrowDropDownIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                ) : (
                  <ArrowRightIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Treatment
                  </Typography>
                  <Typography className="font-bold fs14 gray20 ml5">
                    (List of services used)
                  </Typography>
                </div>
              </div>
              {treatOpen ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Quantity
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Status
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Reason
                      </Typography>
                    </div>
                  </div>
                  <div className="blue-hor-split mt5" />
                  {reqBundle?.treatmentBundleDetails?.map((li, i) => {
                    return (
                      <div
                        className="flex-row-ali-cen mt10 plan-bor"
                        key={i + `${li?.detailId}`}
                      >
                        <div className="w30Per pr10">
                          <Typography className="txt-regular fs12 black18">
                            {li?.name}
                          </Typography>
                        </div>
                        <div className="w20Per pr10">
                          <Typography className="txt-regular fs12 black18">
                            {li?.quantity}
                          </Typography>
                        </div>
                        <div className="w30Per pr10">
                          {!li?.status && !li?.reason ? (
                            <div className="flex-row-ali-cen">
                              <img
                                src={require("../../../../assets/images/png/tick.png")}
                                className="img-wh20 cursor"
                                onClick={() =>
                                  handleUpdateStatus(li, true, "added")
                                }
                              />
                              <img
                                src={require("../../../../assets/images/png/crossRed.png")}
                                className="img-wh20 ml10 cursor"
                                onClick={() =>
                                  handleUpdateStatus(
                                    li,
                                    false,
                                    "Condition not met"
                                  )
                                }
                              />
                            </div>
                          ) : (
                            <div className="w40Per">
                              <Typography
                                className={`${
                                  li?.status && li?.reason === "added"
                                    ? "green-back5"
                                    : "red-back2"
                                } white-color status-con fs12 font-medium`}
                              >
                                {li?.status && li?.reason === "added"
                                  ? "Completed"
                                  : "Not Done"}
                              </Typography>
                            </div>
                          )}
                        </div>
                        <div className="w20Per pr10">
                          {!li?.status && li?.reason === "Condition not met" ? (
                            <CustomSelect
                              list={[
                                {
                                  name: "Condition not met",
                                  value: "Condition not met",
                                },
                                {
                                  name: "Patient disagree",
                                  value: "Patient disagree",
                                },
                                {
                                  name: "Not enough time",
                                  value: "Not enough time",
                                },
                              ]}
                              select
                              handleChange={(e) =>
                                handleUpdateStatus(li, false, e?.target?.value)
                              }
                            />
                          ) : (
                            <Typography className="txt-regular fs12 gray20 ml5">
                              {li?.reason?.length > 0
                                ? li?.reason === "added"
                                  ? "-"
                                  : li?.reason
                                : "-"}
                            </Typography>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </Card>

            {/* <Card sx={cardSty} className="mv20">
              <div className="flex-row-ali-cen cursor" onClick={handlePresOpen}>
                {presOpen ? (
                  <ArrowDropDownIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                ) : (
                  <ArrowRightIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Prescription
                  </Typography>
                  <Typography className="font-bold fs14 gray20 ml5">
                    (optional)
                  </Typography>
                </div>
              </div>
              {presOpen ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w40Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Quantity
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Status
                      </Typography>
                    </div>
                  </div>
                  <div className="blue-hor-split mt5" />
                  {reqBundle?.treatmentBundlePrescription?.map((li, i) => {
                    return (
                      <div
                        className="flex-row-ali-cen mt10 plan-bor"
                        key={i + `${li?.detailId}`}
                      >
                        <div className="w40Per pr10">
                          <Typography className="txt-regular fs12 black18">
                            {li?.name}
                          </Typography>
                        </div>
                        <div className="w30Per pr10">
                          <Typography className="txt-regular fs12 black18">
                            {li?.quantity}
                          </Typography>
                        </div>
                        <div className="w30Per pr10">
                          {!li?.status ? (
                            <div className="flex-row-ali-cen">
                              <img
                                src={require("../../../../assets/images/png/tick.png")}
                                className="img-wh20 cursor"
                                onClick={() =>
                                  handleUpdatePresStatus(
                                    li?.prescriptionId,
                                    true
                                  )
                                }
                              />
                              <img
                                src={require("../../../../assets/images/png/crossRed.png")}
                                className="img-wh20 ml10 cursor"
                                onClick={() =>
                                  handleUpdatePresStatus(
                                    li?.prescriptionId,
                                    false
                                  )
                                }
                              />
                            </div>
                          ) : (
                            <div className="w40Per">
                              <Typography
                                className={`${
                                  li?.status ? "green-back5" : "red-back2"
                                } white-color status-con fs12 font-medium`}
                              >
                                {li?.status ? "Completed" : "Not Done"}
                              </Typography>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </Card> */}
          </Grid>
        </Grid>
      </div>

      <CustomModal
        open={updateModVsble}
        onClose={handleCloseUpdateMod}
        header="Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt10">
              <CustomSelect
                list={getList()}
                value={updateValues?.type}
                label="Select Type"
                newSelect
                disabled
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                Due Date <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="dueDate"
                fullWidth
                value={updateValues?.dueDate}
                mobileDate
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label="Remarks"
                placeholder="Remarks"
                fullWidth
                handleChange={(e) => handleChange("remarks", e?.target?.value)}
                value={updateValues?.remarks}
                multiline
              />
            </Grid>

            {updateValues?.files?.length > 0 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FilesWithCloseButton
                  files={updateValues?.files}
                  onClickFile={(i, file) => handleImageRemove(i)}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomUpload
                onUploadFile={onUploadFile}
                multipleNew
                multiFiles
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-center">
                <div>
                  <CustomButton
                    noBgbtn
                    text="Mark as complete"
                    onClick={handleComplete}
                    tabSelectdBtn
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default Task;
